import { render } from "./FunnelsList.vue?vue&type=template&id=4c212566&scoped=true"
import script from "./FunnelsList.vue?vue&type=script&lang=ts"
export * from "./FunnelsList.vue?vue&type=script&lang=ts"

import "./FunnelsList.vue?vue&type=style&index=0&id=4c212566&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4c212566"

export default script